<template>
    <v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="Captain profile"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <!-- AVATAR -->
        <div class="d-flex justify-center pt-0" v-if="loaded">
            <UserAvatar :photo="item.photo" size="120px" class="elevation-3" style="z-index: 10"/>
        </div> 

        <!-- ALL -->
        <v-card max-width="620px" outlined class="mx-auto" style="margin-top:-70px" v-if="loaded">
            <div :style="{backgroundColor: item.color}">

                <v-img height="170px" :src="require('@/assets/textures/'+item.texture+'A.png')">
                    <div class="headline font-weight-medium text-center white--text" style="padding-top:84px">{{item.name}}</div>
                    
                    <div class="d-flex justify-center align-center white--text">
                        <div class="subtitle-1 text-center" style="line-height:1.2" >
                            <span v-if="item.bio">{{item.bio}}</span>
                            <span v-else style="opacity:.5"><i>- Personal slogan missing -</i></span>
                        </div>
                    </div> 
                </v-img> 

            </div>  

            <v-divider></v-divider>

            <!-- PROFESSION -->
            <v-row>
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-6" style="font-size:11px">MY PROFESSION</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="pt-8 pb-6 px-4">
                    <div v-if="item.profession">
                        {{item.profession}}
                    </div>
                    <div class="grey--text text--darken-1" v-else>
                        Pending...
                    </div>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <!-- AGE -->
            <v-row>
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-6" style="font-size:11px">MY AGE</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="pt-8 pb-6 px-4">
                    <div v-if="item.age">
                        {{item.age}}
                    </div>
                    <div class="grey--text text--darken-1" v-else>
                        Pending...
                    </div>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <!-- COUNTRY -->
            <v-row>
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-6" style="font-size:11px">MY COUNTRY</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="pt-8 pb-6 px-4">
                    <div v-if="item.country">
                        {{item.country}}
                    </div>
                    <div class="grey--text text--darken-1" v-else>
                        Pending...
                    </div>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <!-- DESCRIPTION -->
            <v-row>
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-6" style="font-size:11px">MY DESCRIPTION</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="pt-8 pb-6 px-4">
                    <div v-if="item.description">
                        {{item.description}}
                    </div>
                    <div class="grey--text text--darken-1" v-else>
                        Pending...
                    </div>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <!-- SUPER POWER -->
            <v-row>
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-6" style="font-size:11px">MY SUPER POWER </div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="pt-8 pb-6 px-4">
                    <div v-if="item.superPower">
                        {{item.superPower}}
                    </div>
                    <div class="grey--text text--darken-1" v-else>
                        Pending...
                    </div>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <!-- ATTRIBUTES -->
            <v-row>
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-4" style="font-size:11px">MY MOLECULE</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="px-4 pb-6">
                    <div class="d-flex justify-space-between">
                        <div class="pl-4 pt-4">
                            <div v-if="attributes.length>0">
                                <div v-for="(att, index) in attributes" :key="att.id">
                                    <span class="mr-1 body-1 font-weight-medium" :style="{color: item.color}">{{index+1}}.</span>
                                    <span class="black--text">{{att}}</span>
                                </div>
                            </div>
                            <div class="caption font-weight-medium grey--text" v-else>NO ATTRIBUTES YET</div>

                            <div class="mt-1" v-if="attributes.length>0">
                                <v-btn text class="ml-n4" :style="{color: item.color}" @click="$router.push('/mc/'+item.uid)">
                                    Visit my molecule
                                    <v-icon right size="14px" :color="item.color">fa-external-link-alt</v-icon>
                                </v-btn>
                            </div>
                        </div>
                        <div class="pr-12 mt-6" @click="$router.push('/mc/'+item.uid)" style="cursor:pointer">
                            <v-img :src="require('@/assets/molecule/molecule-center.png')" width="110px"></v-img>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-card>

        <!-- LOADER -->
        <SendingLoader v-if="!loaded"/>
    </v-card>
</template>

<script>
import Users from '@/firebase/users'

export default {
    data: () => ({
        loaded: false,
        item: null,
        attributes: []
    }),
    mounted() {
        this.init();
    },
    methods: {
        reInit() {
            this.attributes = [];
            this.loaded =  false;
            this.init();
        },
        init() {
            Users.get(this.$route.params.id)
                    .then(response => {
                        if (response.status === true) {
                            this.item = response.doc.data();
                            this.item.uid = response.doc.id;
                            if (this.item.attributes && Object.keys(this.item.attributes).length > 0) {
                                this.setAttributes();
                            }
                             this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
                        }
                    });
        },
        setAttributes() {
            let tempo = [];
            for(let key in this.item.attributes) {
                tempo.push(this.item.attributes[key])
            }

            this.attributes = tempo;
        },
        arrayMove (arr, old_index, new_index) {
            if (new_index >= arr.length) {
                var k = new_index - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr;
        }
    }
}
</script>